import { combineReducers } from 'redux'

import { STATUS_ACTIVE, CANCELED_WAITING_LIST } from 'grs/constants'
import {
    SET_RESERVATIONS_BY_PARAM,
    GET_RESERVATIONS_BY_PARAM_ERROR,
    CLEAR_RESERVATIONS_BY_PARAM_ERROR_STATE,
    CLEAR_RESERVATIONS_BY_PARAM_STATE,
    SET_GUEST_RESERVATION_CANCEL_AMEND_POLICY,
    SET_VEHICLE_UPDATED_STATE,
    CLEAR_VEHICLE_UPDATED_STATE,
    UPDATE_VEHICLE_ERROR,
} from 'manage-guest-user-booking/constants'
import { LOGOUT } from 'auth/constants'

import * as constants from './constants'

const selectedReservationId = (state = null, action) => {
    switch (action.type) {
        case constants.OPEN_RESERVATION_DETAILS:
            return action.reservationId
        case constants.CLOSE_RESERVATION_DETAILS:
        case LOGOUT:
            return null
        default:
            return state
    }
}

const status = (state = STATUS_ACTIVE, action) => {
    switch (action.type) {
        case constants.SET_STATUS_FILTER:
            return action.status
        case LOGOUT:
            return STATUS_ACTIVE
        default:
            return state
    }
}

const resultsInitialState = {
    reservations: [],
}

const results = (state = resultsInitialState, { type, result, waitingListKey }) => {
    const { reservations } = state

    switch (type) {
        case constants.GET_RESERVATIONS:
        case constants.SET_STATUS_FILTER:
            return resultsInitialState
        case constants.SET_RESERVATIONS:
            return {
                reservations: [...reservations, ...result],
                areAllVisible: result.length === 0,
            }
        case CANCELED_WAITING_LIST:
            return {
                ...state,
                reservations: reservations.filter(id => id !== waitingListKey),
            }
        case LOGOUT:
            return resultsInitialState
        default:
            return state
    }
}

export const dashboardTransactions = combineReducers({
    selectedReservationId,
    status,
    results,
})

const cancellingInitialState = {
    waitingForCancelConfirmation: false,
    reservationId: '',
}

export function reservationCancelling(state = cancellingInitialState, action) {
    switch (action.type) {
        case constants.SET_CANCEL_RESERVATION_VALUES:
            return {
                ...state,
                ...action.response,
            }
        case constants.CANCEL_RESERVATION:
            return {
                ...state,
                waitingForCancelConfirmation: true,
                reservationId: action.reservationId,
            }
        case constants.CANCEL_RESERVATION_FAILED:
            return {
                ...state,
                waitingForCancelConfirmation: false,
                error: action?.error?.message,
                reservationId: '',
            }
        case constants.RESET_CANCEL_RESERVATION_FAILED_ERROR:
            return {
                ...state,
                error: null,
            }
        case constants.CLOSE_CANCELLATION_MODAL:
            return {
                ...state,
                waitingForCancelConfirmation: false,
                reservationId: '',
            }
        case constants.CLOSE_RESERVATION_DETAILS:
        case LOGOUT:
            return cancellingInitialState
        default:
            return state
    }
}

const guestUserManageBookingIitialState = {
    reservations: null,
    error: null,
    amendPolicy: null,
    vehicleUpdated: null,
    updateVehicleError: null,
}

export function guestUserManageBooking(
    state = guestUserManageBookingIitialState,
    { type, reservations, policy, error, reservationId, vehicles }
) {
    switch (type) {
        case SET_RESERVATIONS_BY_PARAM:
            return { ...state, reservations: reservations }
        case GET_RESERVATIONS_BY_PARAM_ERROR:
            return { ...state, error: true }
        case CLEAR_RESERVATIONS_BY_PARAM_ERROR_STATE:
            return { ...state, error: null }
        case CLEAR_RESERVATIONS_BY_PARAM_STATE:
            return guestUserManageBookingIitialState
        case SET_GUEST_RESERVATION_CANCEL_AMEND_POLICY:
            return { ...state, amendPolicy: policy }
        case SET_VEHICLE_UPDATED_STATE:
            return {
                ...state,
                vehicleUpdated: true,
                reservations: state.reservations?.map(reservation =>
                    reservation.reservationId === reservationId ? { ...reservation, vehicles } : reservation
                ),
            }
        case CLEAR_VEHICLE_UPDATED_STATE:
            return { ...state, vehicleUpdated: null }
        case UPDATE_VEHICLE_ERROR:
            return { ...state, updateVehicleError: error }
        default:
            return state
    }
}
